import React from 'react'
import BusinessPage from '../components/BusinessPage'

const PrivacyPolicy = () => {
  return (
    <BusinessPage title={"Privacy Policy"}>
        <p><strong>Privacy Policy for Bento Delivaz Apps</strong></p>

<p><strong>Effective Date:</strong>&nbsp;22 July 2022</p>

<p><strong>Introduction</strong></p>

<p>Welcome to the privacy policy of Bento Delivaz Limited (&ldquo;Bento Delivaz&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;). We value your privacy and are committed to protecting your personal information. This privacy policy explains how we collect, use, share, and safeguard your information when you use our website and mobile application (collectively referred to as the &ldquo;Platform&rdquo;).</p>

<p>Please read this policy carefully to understand our views and practices regarding your personal data and how we will treat it. By using the Platform, you agree to the terms of this privacy policy. If you do not agree with any part of this policy, please do not use our Platform.</p>

<p><strong>1. Information We Collect</strong></p>

<p>1.1. <strong>Personal Information:</strong> When you register on our Platform, we may collect personal information that can identify you, such as your name, email address, phone number, and delivery address.</p>

<p>1.2. <strong>Payment Information:</strong> We collect payment details necessary to process your orders, including debit card information and bank account details. All payment transactions are processed by a third-party payment processor.</p>

<p>1.3. <strong>Usage Data:</strong> We collect information about your interactions with our Platform, such as your IP address, browser type, operating system, referral URLs, page views, and other usage information.</p>

<p>1.4. <strong>Device Information:</strong> We may collect information about the device you use to access our Platform, including hardware model, operating system and version, unique device identifiers, and mobile network information.</p>

<p>1.5. <strong>Location Information:</strong> We may collect information about your location if you enable location services on your device. This information helps us provide location-based services, such as identifying nearby restaurants.</p>

<p><strong>2. How We Use Your Information</strong></p>

<p>2.1. <strong>Provide and Improve Services:</strong> We use your information to deliver and improve our services, process transactions, manage your account, and respond to your inquiries.</p>

<p>2.2. <strong>Personalization:</strong> We may use your information to personalize your experience on our Platform by providing tailored content and recommendations.</p>

<p>2.3. <strong>Communication:</strong> We use your contact information to send you updates, promotional materials, and other information related to our services. You can opt out of receiving promotional emails at any time.</p>

<p>2.4. <strong>Security:</strong> We use your information to maintain the security of our Platform, prevent fraud, and protect our legal rights.</p>

<p>2.5. <strong>Compliance:</strong> We use your information to comply with legal obligations and enforce our terms and conditions.</p>

<p><strong>3. Sharing Your Information</strong></p>

<p>3.1. <strong>Third-Party Service Providers:</strong> We may share your information with third-party service providers who perform services on our behalf, such as payment processing, data analysis, email delivery, and customer service.</p>

<p>3.2. <strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred as part of the transaction.</p>

<p>3.3. <strong>Legal Requirements:</strong> We may disclose your information if required by law or in response to valid requests by public authorities.</p>

<p>3.4. <strong>Protection of Rights:</strong> We may disclose your information to protect the rights, property, or safety of Bento Delivaz, our users, or others.</p>

<p><strong>4. Security of Your Information</strong></p>

<p>We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, use, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.</p>

<p><strong>5. Your Privacy Rights</strong></p>

<p>5.1. <strong>Access and Correction:</strong> You have the right to access and update your personal information. You can review and change your personal information by logging into your account on the Platform.</p>

<p>5.2. <strong>Data Deletion:</strong> You have the right to request the deletion of your personal information. We will comply with your request unless we have a legitimate reason to retain the information.</p>

<p>5.3. <strong>Opt-Out:</strong> You can opt out of receiving promotional emails from us by following the instructions in those emails. You can also update your email preferences in your account settings.</p>

<p><strong>6. Children&rsquo;s Privacy</strong></p>

<p>Our Platform is not intended for use by children under the age of 18. We do not knowingly collect personal information from children under 18. If we become aware that we have inadvertently received personal information from a user under the age of 18, we will delete such information from our records.</p>

<p><strong>7. Changes to This Privacy Policy</strong></p>

<p>We may update this privacy policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any material changes by posting the updated policy on our Platform and updating the effective date. Your continued use of the Platform after any changes to this policy constitutes your acceptance of the updated policy.</p>

<p><strong>8. Contact Us</strong></p>

<p>If you have any questions or concerns about this privacy policy or our data practices, please contact us at:</p>

<p><strong>Bento Delivaz Limited</strong><br />
Email: hello@bentodelivaz.com</p>

<p>Thank you for trusting Bento Delivaz with your personal information. We are committed to protecting your privacy and providing a secure experience on our Platform.</p>

    </BusinessPage>
  )
}

export default PrivacyPolicy